import "fast-text-encoding"
import "./ssrbase"

import ReactCustom from 'react';
import ReactDOMCustom from 'react-dom';
import * as ReactDOMClientCustom from 'react-dom/client';
import * as ReactDOMServerCustom from 'react-dom/server';


// Expose react dependencies as global variables
globalThis.React = ReactCustom;
globalThis.ReactDOM = ReactDOMCustom;
globalThis.ReactDOMClient = ReactDOMClientCustom;
globalThis.ReactDOMServer = ReactDOMServerCustom;

console.log("Base init loaded");